/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramProductsModeratorControllerModerateMutationRequest,
  TelegramProductsModeratorControllerModerateMutationResponse,
  TelegramProductsModeratorControllerModeratePathParams,
  TelegramProductsModeratorControllerModerate401,
  TelegramProductsModeratorControllerModerate404,
} from '../types/TelegramProductsModeratorControllerModerate.ts';

function getTelegramProductsModeratorModerateUrl(id: TelegramProductsModeratorControllerModeratePathParams['id']) {
  const res = { method: 'PATCH', url: `/api/moderator/telegram/products/moderate/${id}` as const };
  return res;
}

/**
 * {@link /api/moderator/telegram/products/moderate/:id}
 */
export async function telegramProductsModeratorModerate(
  id: TelegramProductsModeratorControllerModeratePathParams['id'],
  data: TelegramProductsModeratorControllerModerateMutationRequest,
  config: Partial<RequestConfig<TelegramProductsModeratorControllerModerateMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramProductsModeratorControllerModerateMutationResponse,
    ResponseErrorConfig<
      TelegramProductsModeratorControllerModerate401 | TelegramProductsModeratorControllerModerate404
    >,
    TelegramProductsModeratorControllerModerateMutationRequest
  >({
    method: 'PATCH',
    url: getTelegramProductsModeratorModerateUrl(id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
